import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';
import { Role } from 'data/models/Role';
import { UserPermissions, PCUserViewModel, UserViewModel } from './model';
import { PCModal } from 'portcall/pcmodal/view';
import { MaxLengthTooltip } from 'portcall/pctooltip/view';
import { ValidationErrorView } from 'core/validationerror/view';
import * as cx from 'classnames';
 
// character limits at which tooltips will be enabled
const MAX_NAME_CHARS = 20,
    MAX_ORG_CHARS = 22;

export const UserPermissionsView = SuperCritical(({ modelContainer } : { modelContainer : () => UserPermissions | null}) => {
    const m = modelContainer();
    return (
        <PCModal className="userpermissions" shown={() => !!modelContainer()} onBackDropClick={m?.HidePopup}>
            <div className={"modal-content " + (m && m.HasPilots() ? "pilot-module" : "")}>
                {/*<loadingindicator params="request: Request" />*/}
                <div className="modal-header pc-modal-header">
                    {m && <button type="button" className="close pc-modal-close" onClick={m.HidePopup}>Close</button>}
                    <h2 className="modal-title pc-modal-title">Manage User Permissions</h2>
                </div>
                {m &&
                    <div>
                        <div className="modal-body">
                            <PermissionsContainer model={m} />
                            <RoleDescriptionsList model={m} />
                        </div>
                        <DeleteUserModal model={m} />
                    </div>
                }
            </div>
        </PCModal>
    );
});

let PermissionsContainer = SuperCritical(({ model: m } : { model : UserPermissions }) =>
    <div className="permissions-container">
        <PermissionsHeader model={m} />
        <PermissionsUserList model={m} />
    </div>
);

let PermissionsHeader = SuperCritical(({ model: m } : { model : UserPermissions }) =>
    <div className="permissions-header">
        {m.CanAssignSiteAdmin() &&
            <div className="site-admin-shading pc-shading-siteadmin"></div>
        }
        <div className="user-image row-item">&nbsp;</div>
        <div className="user-details row-item">&nbsp;</div>
        {m.Model.AssignableRoles().map(r =>
            <div className="perm row-item" key={r.Id()}>{r.Name()}</div>
        )}
    </div>
);

let PermissionsUserList = SuperCritical(({ model: m } : { model : UserPermissions }) =>
    <div className="user-list">
        {m.Users().map(user =>
            <PermissionsUserListUser model={user} assignableRoles={m.Model.AssignableRoles} key={user.Model.Id()} />    
        )}
    </div>
);

let PermissionsUserListUser = SuperCritical(({ model: m, assignableRoles } : { model : PCUserViewModel, assignableRoles : () => Role[] }) =>
    <div>
        <div className="user-image row-item">
            <img className="user-thumbnail" src={m.Model.Image.ThumbUrl()} />
        </div>
        <div className="user-details row-item">
            <MaxLengthTooltip className="user-name pc-text-fixedwidth pc-text-fixedwidth-tooltip"
                text={() => m.Model.FullName()} maxLength={MAX_NAME_CHARS} />
            <MaxLengthTooltip className="organization-name pc-text-fixedwidth pc-text-fixedwidth-tooltip"
                text={() => m.Model.Organization() ? m.Model.Organization()!.Name() : ''} maxLength={MAX_ORG_CHARS} />
        </div>
        {m.User() && <UserRolesList model={m.User()!} assignableRoles={assignableRoles} />}
        <div className="perm row-item delete-user">
            <a href="" className="delete-link" onClick={noDefault(m.ConfirmDeleteUser)}>Delete</a>
        </div>
    </div>
);

let UserRolesList = SuperCritical(({ model: m, assignableRoles } : { model : UserViewModel, assignableRoles : () => Role[] }) =>
    <div className="row-item">
        {assignableRoles().map(r =>
            <div className="perm row-item" key={r.Id()}>
                <input className="checkbox" type="checkbox"
                    checked={m.HasOrImpliesRole(r.Id())}
                    disabled={m.ImpliesOrMaterializesRole(r.Id())}
                    onChange={e => m.ToggleRole(r.Id())} />
            </div>
        )}
    </div>
);

let RoleDescriptionsList = SuperCritical(({ model: m } : { model : UserPermissions }) =>
    <div className="info-container">
        {m.Model.AssignableRoles().map(r =>
            <div key={r.Id()}>
                <div className="permissions-name">{r.Name()}</div>
                <div className="permissions-desc">{r.Description()}</div>
            </div>
        )}
    </div>
);

let DeleteUserModal = SuperCritical(({ model: m } : { model : UserPermissions }) =>
    // (TH 10/6/2016 -- This is a comment from the original HTML template)
    //
    // This isn't a true bootstrap modal, since user permissions is already a modal,
    // and modals inside of modals do funky things.
    <div className={cx('delete-user-popup', {
            open: !!m.DeleteUserModal()
        })}>
        <div className="modal-content">
            <h2 className="modal-title">Delete User</h2>
            {(d => d &&
                <div>
                {!d.ActionSuccess() ?
                    <div>
                        {/*<actionloadingindicator params="action: Action" />*/}
                        <div>
                            Are you sure you want to delete
                            <br />
                            <span>{d.User.FullName() + '?'}</span>
                        </div>
                        <div className="action-btns">
                            <button className="close pc-modal-close delete-close" onClick={d.HideModal}>Cancel</button>
                            <button className="pc-button pc-button-primary" onClick={d.Delete}>Delete</button>
                        </div>
                    </div>
                    :
                    <div>
                        <div className="confirmation-message">
                            {d.User.FullName()} was deleted successfully.
                        </div>
                        <div className="action-btns">
                            <button className="pc-button pc-button-primary done-btn" onClick={d.HideModal}>OK</button>
                        </div>
                    </div>
                }
                </div>
            )(m.DeleteUserModal())}
        </div>
    </div>
);


// WEBPACK FOOTER //
// ./apps/portcall/userpermissions/view.tsx